<template>
  <div class="p" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..." />
     <div class="form-row">
        <h1 class="col-9">Reporte de Kilometros OP por Unidad</h1>
        <div class="col-2">
        </div>
        <router-link to="/home">
          <b-button variant="outline-success" style="margin: 10px">
            <div class="h6 mb-1">
              <b-icon-arrow-left-square></b-icon-arrow-left-square>
            </div>
            <div style="font-size: 12px;">
              Inicio
            </div>
          </b-button>
        </router-link>
      </div>
    
  
    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Seleccione una Unidad</label>
        <multiselect ref="select" v-model="dispositivosSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="dispositivosObtenidos" :multiple="false" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaInicio">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaInicio">
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaFin">
      </div>
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>Distancia</th>
            <th>Fecha inicio</th>
            <th>Fecha fin</th>
            <!-- <th>Horas motor</th> -->
            <!-- <th>Combustible utilizado</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-if="datosIf" >
            <td>{{ datosReporte.unidad }}</td>
            <td>{{ datosReporte.kilometraje }} KM</td>
            
            <td>{{ datosReporte.fecha_inicio }}</td>
            <td>{{ datosReporte.fecha_fin }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>


<script>

/*
if (localStorage.length > 0) {
  var dataSesion = localStorage.setItem("Sesionn", JSON.stringify(dataSesion));
  var dataFromlocal = JSON.parse(localStorage.getItem("Sesionn"));
var dataFromlocalStorageeeee = JSON.parse(localStorage.getItem("Sesionn"));
console.log(dataFromlocalStorageeeee);
console.log(dataFromlocalStorageeeee);

var email = dataFromlocalStorageeeee.email;
var password = dataFromlocalStorageeeee.pass;

var email = dataFromlocal.email;
var password = dataFromlocal.pass;
var email = sessionStorage.getItem('emaill');
var password = sessionStorage.getItem('passwordd');
 //...
 } else {
   */

 //...
 




import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      gruposObtenidos: [],
      gruposSeleccionados: [],
      geocercasObtenidas: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '00:00',
      datosReporte: [],
      loading:false,
      datosIf:false,
    }
  },
  

  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades
    }),

    ...mapState(["cargando"]),

    formatearIds() {
      //let data = '';
   
     
      return this.dispositivosSeleccionados.id;
    },

    formatearName() {
      let data = '';
      var index = 0;
      for (let item of this.dispositivosSeleccionados) {
        (index == 0) ? data += '' + item.name : data += '&deviceId=' + item.id;
        index++;
      }
      return data;
    },

    formatearIdGrupo() {
      let data = '';
      var index = 0;
      for (let item of this.gruposSeleccionados) {
        (index == 0) ? data += 'groupId=' + item.id : data += '&groupId=' + item.id;
        index++;
      }
      return data;
    },
    

    
  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"]),
    ...mapMutations(["setearCargando"]),

    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, headers)
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
    //Zkalish aqui
   
    if (this.fechaInicio !== '' && this.fechaFin !== '' ) {

        let fechaInicio = this.fechaInicio + ' ' + this.horaInicio + ':00';
        let fechaFin = this.fechaFin + ' ' + this.horaFin + ':00';
        
        this.reporteDispositivos(fechaInicio, fechaFin);
        
      }else{
        alert('Debe seleccionar las fechas y una unidad');
      }
    },

    reporteDispositivos(fechaInicio, fechaFin){
        this.loading = true;
        axios.post(`${url2}kilometraje` ,{'deviceid' : this.formatearIds,'FechaInicio' : fechaInicio,'FechaFin' : fechaFin })
        .then(response => {
          this.datosReporte = response.data.datos;
          
          
          this.datosIf = true
          this.loading = false;
         
        })
        .catch(error => {
          alert('No hay registros');
          this.loading = false;
        });
    },

    reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosObtenidos) {
          this.dispositivosSeleccionados.push(item);
      }
    },
    
    selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.gruposObtenidos) {
          this.gruposSeleccionados.push(item);
      }
    },

    removeAll() {
      this.dispositivosSeleccionados = [];
    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['unidad', 'kilometraje', 'fecha', 'fecha_inicio', 'fecha_fin'] } );
        data['A1'].v = 'Dispositivo';
        data['B1'].v = 'Distancia';
        data['C1'].v = 'Fecha';
        data['D1'].v = 'Fecha Inicio';
        data['E1'].v = 'Fecha Fin';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
     //   XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['unidad', 'kilometraje', 'fecha', 'fecha_inicio', 'fecha_fin'] } );
        data['A1'].v = 'Dispositivo';
        data['B1'].v = 'Distancia';
        data['C1'].v = 'Fecha';
        data['D1'].v = 'Fecha Inicio';
        data['E1'].v = 'Fecha Fin';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
       // XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenertoken() {
      
    },

    obtenerDispositivos() {
      
      this.loading = true;
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          alert('Ha ocurrido un error');
        }); 

    },


    
    
     
  },

  created() {
    this.obtenerDispositivos();
    //this.obtenerGrupos();
    //this.obtenerGeocercas();
    // this.obtenerUnidades();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    console.log(sessionStorage.aleatorio);
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .p{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>